<template>
  <div class="word-book-wrapper">
    <div class="list-wrapper">
      <van-empty v-if="list.length == 0" description="暂无记录"/>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="list.length != 0 ? '' : ''"
          @load="onLoad"
        >
          <WordbookCell
            :curAudioUrl="curAudioUrl"
            v-for="(item, index) in list"
            :key="index + 1000"
            :item="item"
            @playAudio="val => _actionPlayAudio(val)"
          ></WordbookCell>
        </van-list>
      </van-pull-refresh>
    </div>
    <audio
      ref="audioPlayer"
      :src="curAudioUrl"
      @ended="audioEnd"
    ></audio>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {getWordListWord} from "@/api/vocab";
  import WordbookCell from "./WordbookCell";

  export default {
    name: "Newwordbook",
    data() {
      return {
        list: [],
        loading: false,
        finished: true,
        refreshing: false,
        startId: 0,
        curAudioUrl: '',
      }
    },

    components: {
      WordbookCell
    },

    activated() {
      //开始下载刷新
      this.list = [];
      this.startId = 0;
      this.refreshing = true;
      this.onRefresh()
    },

    methods: {
      //=========audio==========
      audioEnd() {
        this.curAudioUrl = ''
      },

      //================action==================
      //点击发音
      _actionPlayAudio(audioUrl) {
        console.log(audioUrl)
        if (this.curAudioUrl == audioUrl) {
          return
        }
        let _Player = this.$refs.audioPlayer;
        _Player.pause();
        this.curAudioUrl = audioUrl;
        setTimeout(() => {
          _Player.play();
        }, 200)
      },

      onLoad() {
        let params = {
          size: 10,
          startId: this.startId,
        };
        this.loading = true;
        getWordListWord(params).then(res => {
          this.loading = false;
          if (res.code === 0) {
            if (this.refreshing) {
              this.list = [];
              this.refreshing = false;
            }
            let tempArr = res.data;
            this.list = [...this.list, ...tempArr];
            this.list.forEach(item => {
              Vue.set(item, 'isAddToNewWord', true)
            })
            //记录最后一个单词的item userwordid
            const listLength = this.list.length
            if (listLength > 0){
              let lastItem = this.list[listLength - 1];
              this.startId = lastItem.userNewWordId;
            }

            if (tempArr.length < 10) {
              this.finished = true
            }else {
              this.finished = false
            }
          }
        }).catch((err) => {
          this.$toast(JSON.stringify(err))
          this.loading = false;
          this.finished = true;
        })
      },

      onRefresh() {
        // 清空列表数据
        this.startId = 0;
        this.finished = false;
        this.onLoad();
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .word-book-wrapper {
    padding: 10px 0;
    box-sizing: border-box;
    min-height: 100vh;
    background-color: #F2F6F9;
  }
  .list-wrapper{
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// app/pages/tabs/NewWordBook/index.vue